$(document).ready(function () {

  // if (!$.cookie('biox4-NS')) {
  //   videojs('vslVideo').ready(function () {
  //     this.on('timeupdate', function () {
  //       if (this.currentTime() >= (60 * 2) || this.currentTime() == this.duration()) {
  //         $("#vslCTA").removeClass('hidden').addClass('visible');
  //       }
  //       // console.log(this.currentTime());
  //     })
  //   });

  //   $.cookie("biox4-NS", 1, { expires: 7 });
  // }
  // else {
  //   $("#vslCTA").removeClass('hidden').addClass('visible');
  // }

  function addCookie() {
    if ($('#vslVideo').length && !$.cookie('biox4-NS')) {
      videojs('vslVideo').ready(function () {
        this.on('timeupdate', function () {
          if (this.currentTime() >= (60 * 2) || this.currentTime() == this.duration()) {
            $("#vslCTA").removeClass('hidden').addClass('visible');
          }
        })
      })
  
      $.cookie("biox4-NS", 1, { expires: 7 });
    } else if ($('#vslVideo').length || $.cookie('biox4-NS')) {
        $("#vslCTA").removeClass('hidden').addClass('visible');
    }
  } 

  addCookie();

  //- Play full video if clicked play button on thumbnail video (appers only if we have videoThumbnail string passed to vslSection component)
  $('#vslVideoThumb .vjs-big-play-button').on('click touchend', function(){
    const fullVideoUrl = $('#vslVideoThumb').data('full-video');
    $('#vslVideoThumb').attr('id', 'vslVideo');
    $('#vslVideo video').attr('src', fullVideoUrl);
    videojs('vslVideo').controls(true);
    videojs('vslVideo').play();
    videojs('vslVideo').muted(false);
    addCookie();
  });

  //- Set current Year to footer Copyright
  let thisDate = new Date();
  $('#year').html(thisDate.getFullYear());


  //Time on page GA events
  /*
  var myTimer =  window.setInterval((function(){
    var start = Date.now();
    var textNode = 0 ;
    return function() {
         textNode = Math.floor((Date.now()-start)/1000);
        console.log('time on page: ', textNode)
        let TOP;
        if(textNode == 3){
          console.log('time on page: ', textNode);
           TOP = ( textNode + ' seconds') ;
          ga('send', { hitType: 'event', eventCategory: 'Time on page', eventLabel: TOP});
 
        }else if(textNode == 10){
          console.log('time on page: ', textNode);
            TOP = ( textNode + ' seconds') ;
          ga('send', { hitType: 'event', eventCategory: 'Time on page', eventLabel: TOP});
 
        }else if(textNode == 15){
          console.log('time on page: ', textNode);
            TOP = ( textNode + ' seconds') ;
          ga('send', { hitType: 'event', eventCategory: 'Time on page', eventLabel: TOP});
 
 
        }else if(textNode == 30){
          console.log('time on page: ', textNode);
            TOP = ( textNode + ' seconds') ;
          ga('send', { hitType: 'event', eventCategory: 'Time on page', eventLabel: TOP});
 
 
        }else if(textNode == 45){
          console.log('time on page: ', textNode);
            TOP = ( textNode + ' seconds') ;
          ga('send', { hitType: 'event', eventCategory: 'Time on page', eventLabel: TOP});
 
 
        }else if(textNode == 60){
          console.log('time on page: ', textNode , ' 1 Minute');
          ga('send', { hitType: 'event', eventCategory: 'Time on page', eventLabel: '1 Minute'});
 
 
        }else if(textNode == 180){
          console.log('time on page: ', textNode , ' 3 Minute');
          ga('send', { hitType: 'event', eventCategory: 'Time on page', eventLabel: '3 Minute'});
 
 
        }else if(textNode == 300){
          console.log('time on page: ', textNode , '5 Minute');
          ga('send', { hitType: 'event', eventCategory: 'Time on page', eventLabel: '5 Minute'});
 
          stopTimer();
        }
 
         };
    }()), 1000);
 
    function stopTimer() {
      clearInterval(myTimer);
    }
 
*/
});
